import {Injectable} from '@angular/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';

import {Observable} from 'rxjs';

import {FirebaseAbstractService} from '@q9elements/ui-kit/refmodels';
import {IGPTChatMeta, IGPTConversation} from '../models/elementsGpt.interfaces';

interface PromptConfig {
  question: string;
  scoreThreshold: number;
  maxCharacters: number;
  contextPrefix: string;
}

interface CompletionConfig {
  topK;
  number;
  model: string;
  temperature: number;
  topP: number;
  maxTokens: number;
}

interface ConversationConfig {
  completionConfig: CompletionConfig;
  promptConfig: PromptConfig;
}

export interface ExternalGptConfig {
  enabled: boolean;
  validCredentials: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ElementsGptService extends BaseDaoService {
  constructor(private firebaseSvc: FirebaseAbstractService) {
    super();
  }

  public getConversations(refModelId: string): Observable<IGPTChatMeta> {
    return this.http.get<IGPTChatMeta>(
      `${this.apiUrl}/elements-gpt/${refModelId}/refmodel/conversations`
    );
  }

  public buildIndex(refModelId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/elements-gpt/${refModelId}/refmodel/index`, {});
  }

  public createCompletion(refModelId: string, conversationConfig): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/elements-gpt/${refModelId}/refmodel/completion`,
      conversationConfig
    );
  }

  public subscribeToGptAnswer(path, callback: (snapshot) => void) {
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public unsubscribeFromGptAnswer(path) {
    this.firebaseSvc.getReference(path).off();
  }

  public editConversation(
    rmId: string,
    convId: string,
    title: string
  ): Observable<IGPTConversation> {
    return this.http.put<IGPTConversation>(
      `${this.apiUrl}/elements-gpt/${rmId}/refmodel/conversation/${convId}`,
      {title}
    );
  }

  public deleteConversation(rmId: string, convId: string): Observable<null> {
    return this.http.delete<null>(
      `${this.apiUrl}/elements-gpt/${rmId}/refmodel/conversation/${convId}`
    );
  }

  public getEnterprisePermission(): Observable<ExternalGptConfig> {
    const url = `${this.apiUrl}/enterprises/external-gpt-config`;

    return this.http.get<ExternalGptConfig>(url);
  }
}
